import script from "./WorkOrderBase.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkOrderBase.vue?vue&type=script&setup=true&lang=js"

import "./WorkOrderBase.vue?vue&type=style&index=0&id=6813615c&scoped=true&lang=css"

import exportComponent from "D:\\Workspace-idea\\vue-space\\hwoms-vue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6813615c"]])

export default __exports__